module.exports = __webpack_public_path__ + "images/6e419734e7c8b33138da2927ee7c7675-Frontpoint_illu_lineart_Logo.png";